export const AdminFeatureFlagsName = 'AdminFeatureFlags';
